export default __webpack_public_path__ + "static/bubble-with-negative-values-5cad855d54c2db7015f150e82bb989a3.png";